module.exports = __webpack_public_path__ + "media/dissolve.35f97255.webm";